export default {
    indexTeacherTimeBank:           { method: 'get',    url: 'teacher_time_bank' },
    showTeacherTimeBank:            { method: 'get',    url: 'teacher_time_bank/{id}' },
    summaryTeacherTimeBank:         { method: 'get',    url: 'teacher_time_bank/summary' },
    exportTeacherTimeBank:          { method: 'post',   url: 'teacher_time_bank/export' }
}
